<div class="header" fxLayout="row" fxLayoutAlign="space-between center">
  <div fxFlexFill fxLayout="row" fxLayoutAlign="space-between start">
    <div fxLayout="row" style="width: 85px;">Date</div>
    <div fxFlex="10">Invoice</div>
    <div fxFlex="15" fxFlexFill fxLayout="column" fxLayoutAlign="start start">Description</div>
    @if (useUnit) {
      <div class="number-header" fxFlex="5" fxFlexFill fxLayout="row" fxLayoutAlign="end">
        Invoiced<br>Units</div>
      }
      <div class="number-header" fxFlex="10" fxLayout="row" fxLayoutAlign="end">Invoiced<br>Price</div>
      @if (useTax) {
        <div class="number-header" fxFlex="10" fxLayout="row" fxLayoutAlign="end">Invoiced<br>Sales Tax
        </div>
      }
      @if (useShipping) {
        <div class="number-header" fxFlex="10" fxLayout="row" fxLayoutAlign="end">
          Invoiced<br>Shipping</div>
        }
        <div class="number-header" fxFlex="10" fxLayout="row" fxLayoutAlign="end"><strong>Invoiced<br>Total</strong>
      </div>
      @if (usePaymentDate) {
        <div fxFlex="10" fxLayout="row" style="padding-left: 8px;">Payment<br>Date</div>
      }
      @if (usePaymentNumber) {
        <div fxFlex="10" fxLayout="row">Payment<br>Number</div>
      }
    </div>
  </div>

  <mat-divider></mat-divider>

  @if (!hasInvoices()) {
    <div fxLayout="row" fxLayoutAlign="center center">
      No Invoices
    </div>
  }

  @if (hasInvoices()) {
    <div>
      @for (invoice of invoices; track invoice) {
        <div>
          <div fxFlexFill fxLayout="row" fxLayoutAlign="space-between start">
            <div fxLayout="row" style="width: 85px;">{{invoice.Date}}</div>
            <div fxFlex="10">{{invoice.Number}}</div>
            <div fxFlex="15" fxFlexFill fxLayout="column" fxLayoutAlign="start start">{{invoice.Description}}</div>
            @if (useUnit) {
              <div fxFlex="5" fxLayout="row" fxLayoutAlign="end">{{invoice.Units}}</div>
            }
            <div fxFlex="10" fxLayout="row" fxLayoutAlign="end">{{invoice.Amount | currency}}</div>
            @if (useTax) {
              <div fxFlex="10" fxLayout="row" fxLayoutAlign="end">{{invoice.SalesTax | currency}}</div>
            }
            @if (useShipping) {
              <div fxFlex="10" fxLayout="row" fxLayoutAlign="end">{{invoice.Shipping| currency}}</div>
            }
            <div fxFlex="10" fxLayout="row" fxLayoutAlign="end"><strong>{{invoice.InTotal | currency}}</strong></div>
            @if (usePaymentDate) {
              <div fxFlex="10" fxLayout="row">&nbsp;&nbsp;{{invoice.PaidDate | date:'MM/dd/yyyy' }}
              </div>
            }
            @if (usePaymentNumber) {
              <div fxFlex="10">{{invoice.PaymentNumber}}</div>
            }
          </div>
          <mat-divider></mat-divider>
        </div>
      }
      <div fxFlexFill fxLayout="row" fxLayoutAlign="space-between start">
        <div style="width: 85px;"><strong>Totals:</strong></div>
        <div fxFlex="10"></div>
        <div fxFlex="15"></div>
        @if (useUnit) {
          <div fxFlex="5"></div>
        }
        <div fxFlex="10" fxLayout="row" fxLayoutAlign="end">{{total.Amount | currency}}</div>
        @if (useTax) {
          <div fxFlex="10" fxLayout="row" fxLayoutAlign="end">{{total.SalesTax | currency}}</div>
        }
        @if (useShipping) {
          <div fxFlex="10" fxLayout="row" fxLayoutAlign="end">{{total.Shipping| currency}}</div>
        }
        <div fxFlex="10" fxLayout="row" fxLayoutAlign="end"><strong>{{total.InTotal | currency}}</strong></div>
        @if (usePaymentDate) {
          <div fxFlex="10"></div>
        }
        @if (usePaymentNumber) {
          <div fxFlex="10"></div>
        }
      </div>
      <mat-divider></mat-divider>
    </div>
  }